import CaptableSecurities from './container';

export default CaptableSecurities;
